import { render } from "./allView.vue?vue&type=template&id=6e0272eb"
import script from "./allView.vue?vue&type=script&lang=js"
export * from "./allView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__